import styled from "styled-components";
import {
  Button as AntButton,
  Typography,
  Form as AntForm,
  Input as AntInput,
} from "antd";
import { AuthHeadingBg } from "@assets/auth";
import lightTheme from "@styles/theme";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: center;

  .ant-btn-primary {
    width: 100%;
    height: 56px;
  }
  position: relative;

`;

export const Heading = styled.div`
  width: 100%;
  height: 355px;
  background-image: url(${AuthHeadingBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-bottom-left-radius: 23px;
  border-bottom-right-radius: 23px;

  display: flex;
  flex-direction: column;
  justify-content: baseline;
  align-items: center;

  @media screen and (max-width: 400px) {
    height: 325px;
  }
  @media screen and (max-width: 350px) {
    height: 295px;
  }

  @media screen and (max-width: 330px) {
    height: 275px;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: ${(props) => (props.backKey ? "end" : "space-between")};
  align-items: center;
  height: 37px;
  margin: 24px 0 0 0;
`;

export const ArrowIconWrapper = styled.div`
  margin: 0 0 0 20px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;


export const BackButton = styled.div`
  padding: 5px 16px;
  border-radius: 16px;
  background: #FFF;

  color: #004F9C;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const SkipButton = styled.div`
  padding: 5px 16px;
  border-radius: 16px;
  background: #FFF;
  margin: 0 20px 0 0;

  color: #004F9C;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Title = styled(Typography.Title)`
  color: #000;
  text-align: center;
  font-size: 21px !important;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 28px 0 0 0;

`;

export const ContentContainer = styled.div`
  width: calc(100% - 32px);
  margin: 0px auto 24px;
  padding: 0 16px 0;
`;

export const Form = styled(AntForm)`
  margin: 20px 0 0 0;
  width: 100%;
  text-align: center;

  .ant-form-item{
    margin-bottom: 16px;
  }

  .ant-form-item-label {
    margin: 0px 0 2px 8px;
    margin-left: 16px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #004F9C;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
  }

  .ant-form-item-explain{
    text-align: left;
    margin-left: 16px;
  }
`;
export const Input = styled(AntInput)`
  -moz-appearance: textfield;
  padding-left: 16px; 
  border-radius: 16px;
  background: #D9D9D9;
  height: 56px;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #000;
 
  text-align: left;
  margin-bottom: 5px;

  &::placeholder {
    color: rgba(0, 54, 117, 0.50);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const TextButton = styled(AntButton)`
  margin: -25px 0 0 0;

  float: right;
  text-align: right;
  color: #004F9C;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Divider = styled.div`
  margin: 0 auto 32px;
  width: fit-content;
  border-radius: 16px;
  background: #D9D9D9;
  padding: 2px 20px;
  font-size: 16px;
  font-weight: 400;
  color: #004F9C;
`;

export const DividerForRegister = styled(Divider)`
  margin: 18px auto !important;
`

export const LoginButton = styled(AntButton)`
  margin: 7px 0 0 0;
  background: ${(props) =>
  props.disabled
    ? "#DEEDFF"
    : "linear-gradient(90deg, #0060BE 0%, #04AEED 100%)"} !important;

  color: ${(props) =>
  props.disabled
    ? "rgba(0, 54, 117, 0.50)"
    : "#fff"} ;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const RegisterButton = styled(AntButton)`
  margin: 0 0 20px;
  border-radius: 16px;
  border: 1.5px solid #0161BF !important;
  background: #FFF !important;

  color: #004F9C !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &:hover {
    color: #004F9C !important;
    background: #FFF !important;
  }
`;

export const GoToPromoRegisterButton = styled(AntButton)`
  border-radius: 26px !important;
  background: linear-gradient(0deg, #0060BE 0%, #04AEED 100%);

  color: #DEEDFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  margin-top: 10px;

  &:hover {
    background: linear-gradient(0deg, #0060BE 0%, #04AEED 100%) !important;
  }
`

export const ContinueButton = styled(AntButton)`

  background: ${(props) =>
  props.disabled
    ? "#E1F0FF"
    : "linear-gradient(90deg, #0060BE 0%, #04AEED 100%)"} !important;
  
  border: none !important;
  border-radius: 26px !important;
  &:disabled {
    color: #1E1E1E !important;
  }
`;

export const TelegramLoginButton = styled.div`
margin-top: 24px;
width: 100%;
height: 52px;
border-radius: 26px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: ${props => props.theme.buttonColor};
cursor: pointer;
position: relative;

font-size: 16px;
font-weight: bold;
color: #fff;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const SocialLoginWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const SpaceBetweenTopBottom = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const TelegramRegisterButton = styled.div`
width: 100%;
height: 52px;
border-radius: 26px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: ${props => props.theme.buttonColor};
cursor: pointer;
position: relative;

font-size: 16px;
font-weight: bold;
color: #fff;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;